import { messageCenter } from 'mt-ui'
import conf from '@mediatool/mt-frontend/lib/conf'

module.exports = messageCenter(conf)
